import { render } from "./HeaderText.vue?vue&type=template&id=51b5694e&scoped=true"
import script from "./HeaderText.vue?vue&type=script&lang=js"
export * from "./HeaderText.vue?vue&type=script&lang=js"

import "./HeaderText.vue?vue&type=style&index=0&id=51b5694e&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b5694e"]])

export default __exports__